import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Cookies from "js-cookie";
import { showNotification } from "../../utils";
import "react-notifications-component/dist/theme.css";
import ClosedIcon from "../../assets/icons/colored/ClosedIcon.svg";
import OpenedIcon from "../../assets/icons/colored/OpenedIcon.svg";
import "./pace_modify.css";

const TreeNode = ({ label, children, isOpen, toggleNode, hasChildren }) => {
  return (
    <div style={{ display: "flex", flexDirection: "column" }}>
      <div
        onClick={hasChildren ? toggleNode : null}
        style={{
          cursor: hasChildren ? "pointer" : "default",
          display: "flex",
        }}
      >
        {hasChildren && (
          <img
            src={isOpen ? OpenedIcon : ClosedIcon}
            alt={isOpen ? "Opened" : "Closed"}
            style={{ marginRight: 8 }}
          />
        )}
        <span style={{ fontWeight: "bold" }}>{label}:</span>
      </div>
      {isOpen && hasChildren && (
        <div style={{ marginLeft: 20 }}>{children}</div>
      )}
      {!hasChildren && (
        <div style={{ marginLeft: 28, color: "black" }}>{children}</div>
      )}
    </div>
  );
};

const TreeView = ({ data, handleReset, handleDefault }) => {
  const renderTree = (obj, parentKey = "") => {
    return Object.keys(obj).map((key, index) => {
      const value = obj[key];
      const hasChildren = value !== null && typeof value === "object";
      const nodeKey = `${parentKey}${key}`;

      const isAsynchronous = parentKey.includes("asynchronous"); // Verificar si es una clase "asynchronous"

      return (
        <TreeNodeWrapper
          key={index}
          label={key}
          hasChildren={hasChildren}
          nodeKey={nodeKey}
          handleReset={handleReset}
          handleDefault={handleDefault}
        >
          {hasChildren ? (
            renderTree(value, `${nodeKey}.`)
          ) : (
            <>
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <span>{value !== null ? String(value) : "No visto"}</span>
                <span>|</span>
                {isAsynchronous ? (
                  <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <span>True</span>
                      <input
                        type="radio"
                        name={`asynchronous-${nodeKey}`}
                        checked={value === true}
                        onChange={() => handleDefault(nodeKey, true)}
                      />
                    </div>
                    <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                      <span>False</span>
                      <input
                        type="radio"
                        name={`asynchronous-${nodeKey}`}
                        checked={value === false}
                        onChange={() => handleDefault(nodeKey, false)}
                      />
                    </div>
                  </div>
                ) : (
                  <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                    <span>{value !== null ? "Reiniciar" : "Default"}</span>
                    <input
                      type="checkbox"
                      onChange={() =>
                        value !== null
                          ? handleReset(nodeKey)
                          : handleDefault(nodeKey, null)
                      }
                    />
                  </div>
                )}
              </div>
            </>
          )}
        </TreeNodeWrapper>
      );
    });
  };

  return <div>{renderTree(data)}</div>;
};

const TreeNodeWrapper = ({
  label,
  children,
  hasChildren,
  nodeKey,
  handleReset,
  handleDefault,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleNode = () => setIsOpen(!isOpen);

  return (
    <TreeNode
      label={label}
      isOpen={isOpen}
      toggleNode={toggleNode}
      hasChildren={hasChildren}
    >
      {children}
    </TreeNode>
  );
};

const absenceBucketsForClass = (pace, classId) => {
  const progress = pace?.content_progress;
  const buckets = [];
  if (!progress || typeof progress !== "object") return buckets;

  Object.values(progress.workshops || {}).forEach((value) => {
    if (value !== null && value !== "" && Number(value) === classId) {
      buckets.push("workshops");
    }
  });

  Object.values(progress.units || {}).forEach((unit) => {
    if (!unit || typeof unit !== "object") return;
    Object.values(unit.regular_sessions || {}).forEach((value) => {
      if (value !== null && value !== "" && Number(value) === classId) {
        buckets.push("regular_sessions");
      }
    });
    if (unit.exam !== null && unit.exam !== "" && Number(unit.exam) === classId) {
      buckets.push("exams");
    }
  });

  return [...new Set(buckets)];
};

const Pace_modify = () => {
  const [customerID, setCustomerID] = useState("");
  const [responseData, setResponseData] = useState(null);
  const [notFound, setNotFound] = useState(false);
  const [classIdByPace, setClassIdByPace] = useState({});

  const navigate = useNavigate();

  // Estados para el diálogo de confirmación
  const [isConfirmationDialogOpen, setConfirmationDialogOpen] = useState(false);
  const [dataToSend, setDataToSend] = useState(null);
  const [pendingConvert, setPendingConvert] = useState(null);

  const handleSearch = () => {
    var getPaceUrl = `${process.env.REACT_APP_API_URL}/api/v1/pace/student/progress`;
    fetch(getPaceUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
      body: JSON.stringify({ customer_id: customerID }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.message);
          });
        } else if (response.status === 200) {
          showNotification("Usuario encontrado", "¡Bien!", "success");
          return response.json();
        }
      })
      .then((data) => {
        if (data) {
          setResponseData(data);
          setDataToSend({ ...data }); // Asegurar que dataToSend está inicializado con los datos correctos
          setClassIdByPace({});
          setPendingConvert(null);
          setNotFound(false); // Reiniciar el estado de "id no encontrado"
        }
      })
      .catch((error) => {
        showNotification("Error", error.message, "warning");
        setResponseData(null);
        setNotFound(true); // Establecer "id no encontrado" en verdadero
      });
  };

  const handleClear = () => {
    setCustomerID(""); // Borra el customerID
    setResponseData(null); // Borra los datos de respuesta
    setClassIdByPace({});
    setPendingConvert(null);
  };

  const handleReset = (path) => {
    setPendingConvert(null);
    modifyData(path, null);
    setConfirmationDialogOpen(true);
  };

  const handleDefault = (path, newValue = null) => {
    setPendingConvert(null);
    if (path.includes("asynchronous")) {
      modifyData(path, newValue); // newValue será true o false según la selección del usuario
    } else {
      modifyData(path, 0); // Para los demás casos, sigue enviando 0 como valor por defecto
    }
    setConfirmationDialogOpen(true);
  };

  const modifyData = (path, newValue) => {
    const pathArray = path.split(".");
    const newResponseData = { ...dataToSend };

    let currentLevel = newResponseData.active_paces[0]; // Accedemos a la raíz del pace

    // Verificamos si estamos modificando "absences"
    if (pathArray[0] === "absences") {
      let absencesCategory = pathArray[1]; // Puede ser "workshops" o "regular_sessions"
      let index = parseInt(pathArray[2]); // Posición en el array

      if (!isNaN(index)) {
        // Aseguramos que la clave existe
        if (!currentLevel.absences[absencesCategory]) {
          currentLevel.absences[absencesCategory] = [];
        }

        // Si el valor es null, eliminamos el índice (reinicio)
        if (newValue === null) {
          currentLevel.absences[absencesCategory].splice(index, 1);
        } else {
          currentLevel.absences[absencesCategory][index] = newValue;
        }
      }
    } else if (pathArray[0] === "approach") {
      let approachCategory = pathArray[1]; // "regular_sessions"
      let index = parseInt(pathArray[2]);

      if (!isNaN(index)) {
        if (!currentLevel.approach) {
          currentLevel.approach = { regular_sessions: [] };
        }
        if (!currentLevel.approach[approachCategory]) {
          currentLevel.approach[approachCategory] = [];
        }

        if (newValue === null) {
          currentLevel.approach[approachCategory].splice(index, 1);
        } else {
          currentLevel.approach[approachCategory][index] = newValue;
        }
      }
    } else {
      // Modificación normal para content_progress
      currentLevel = currentLevel.content_progress;

      for (let i = 0; i < pathArray.length - 1; i++) {
        if (!currentLevel[pathArray[i]]) {
          currentLevel[pathArray[i]] = {};
        }
        currentLevel = currentLevel[pathArray[i]];
      }

      currentLevel[pathArray[pathArray.length - 1]] = newValue;
    }

    setDataToSend(newResponseData);
  };

  // Función para manejar la cancelación del diálogo de confirmación
  const handleConvert = (pace, paceIndex) => {
    if (isConfirmationDialogOpen) {
      showNotification(
        "Error",
        "Confirma o cancela el cambio pendiente",
        "warning"
      );
      return;
    }

    const rawId = String(classIdByPace[paceIndex] || "").trim();
    if (!/^\d+$/.test(rawId)) {
      showNotification("Error", "Ingresa un ID de clase válido", "warning");
      return;
    }

    const classId = Number(rawId);
    const buckets = absenceBucketsForClass(pace, classId);

    if (buckets.length === 0) {
      showNotification(
        "Error",
        "El ID no está en el progreso de este estudiante",
        "warning"
      );
      return;
    }

    if (buckets.length > 1) {
      showNotification(
        "Error",
        "Ese ID está en más de un tipo de clase. No se guardó nada",
        "warning"
      );
      return;
    }

    const bucket = buckets[0];
    const currentAbsences = pace.absences?.[bucket] || [];
    const alreadyAbsent = currentAbsences.some(
      (id) => id !== null && id !== "" && Number(id) === classId
    );

    if (alreadyAbsent) {
      showNotification(
        "Error",
        "Esta clase ya está registrada como inasistencia",
        "warning"
      );
      return;
    }

    const nextPace = JSON.parse(JSON.stringify(pace));
    if (!nextPace.absences) {
      nextPace.absences = { workshops: [], regular_sessions: [], exams: [] };
    }
    if (!Array.isArray(nextPace.absences[bucket])) {
      nextPace.absences[bucket] = [];
    }
    nextPace.absences[bucket].push(classId);
    setPendingConvert(nextPace);
    setConfirmationDialogOpen(true);
  };

  const handleCancel = () => {
    setConfirmationDialogOpen(false);
    setPendingConvert(null);
    setDataToSend({ ...responseData }); // Restaura los cambios en el estado
  };

  const savePace = (pace) => {
    var updatePaceUrl = `${process.env.REACT_APP_API_URL}/api/v1/pace/student`;
    fetch(updatePaceUrl, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + Cookies.get("token"),
      },
      body: JSON.stringify({
        customer_id: customerID,
        pace,
      }),
    })
      .then((response) => {
        if (!response.ok) {
          return response.json().then((data) => {
            throw new Error(data.message);
          });
        } else if (response.status === 200) {
          showNotification(
            "¡Éxito!",
            "Se actualizó el pace correctamente",
            "success"
          );
          setNotFound(false);
          setTimeout(() => {
            window.location.reload();
          }, 1500);
        }
      })
      .catch((error) => {
        showNotification("Error", error.message, "danger");
        setResponseData(null);
        setNotFound(true);
      });
  };

  // Función para manejar la confirmación del diálogo
  const handleConfirm = () => {
    setConfirmationDialogOpen(false);
    if (pendingConvert) {
      const pace = pendingConvert;
      setPendingConvert(null);
      savePace(pace);
      return;
    }
    if (dataToSend && dataToSend.active_paces) {
      var updatePaceUrl = `${process.env.REACT_APP_API_URL}/api/v1/pace/student`;
      fetch(updatePaceUrl, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + Cookies.get("token"),
        },
        body: JSON.stringify({
          customer_id: customerID,
          pace: dataToSend.active_paces[0],
        }),
      })
        .then((response) => {
          if (!response.ok) {
            return response.json().then((data) => {
              throw new Error(data.message);
            });
          } else if (response.status === 200) {
            showNotification(
              "¡Éxito!",
              "Se actualizó el pace correctamente",
              "success"
            );
            setResponseData(dataToSend);
            setNotFound(false); // Reiniciar el estado de "id no encontrado"
            setTimeout(() => {
              window.location.reload();
            }, 1500);
          }
        })
        .catch((error) => {
          showNotification("Error", error.message, "danger");
          setResponseData(null);
          setNotFound(true); // Establecer "id no encontrado" en verdadero
        });
    }
  };

  return (
    <div className="pace_container">
      <div className="pace_show">
        <h1>Modificar Pace del Estudiante</h1>
        <input
          type="text"
          placeholder="Ingrese el customer ID"
          value={customerID}
          onChange={(e) => setCustomerID(e.target.value)}
        />
        <div className="pace_submit_container">
          <input
            className="pace_search-button"
            type="button"
            value="Buscar"
            onClick={handleSearch}
          />
          <input
            className="pace_clear-button"
            type="button"
            value="Borrar"
            onClick={handleClear}
          />
        </div>
        {notFound && <p>ID No encontrado</p>}
        {responseData && responseData.active_paces ? (
          <div className="pace_info-tables">
            {responseData.active_paces.map((pace, index) => (
              <div key={index}>
                <h3>Programa: {pace.program}</h3>
                <p>Lenguaje: {pace.language}</p>
                <p>Nivel: {pace.level}</p>
                <h4>Progreso:</h4>
                <TreeView
                  data={pace.content_progress}
                  handleReset={handleReset}
                  handleDefault={handleDefault}
                />
                <h4>Ausencias:</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Talleres</th>
                      <th>Sesión Regular</th>
                      <th>Examen</th>
                      <th>Control de asistencia</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {pace.absences.workshops.length > 0
                          ? pace.absences.workshops.map((workshop, idx) => (
                              <div key={idx}>
                                {workshop}
                                <label>
                                  Reiniciar{" "}
                                  <input
                                    type="checkbox"
                                    onChange={() =>
                                      handleReset(`absences.workshops.${idx}`)
                                    }
                                  />
                                </label>
                              </div>
                            ))
                          : "No hay ausencias"}
                      </td>
                      <td>
                        {pace.absences.regular_sessions.length > 0
                          ? pace.absences.regular_sessions.map(
                              (session, idx) => (
                                <div key={idx}>
                                  {session}
                                  <label>
                                    Reiniciar{" "}
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleReset(
                                          `absences.regular_sessions.${idx}`
                                        )
                                      }
                                    />
                                  </label>
                                </div>
                              )
                            )
                          : "No hay ausencias"}
                      </td>
                      <td>
                        {pace.absences.exams && pace.absences.exams.length > 0
                          ? pace.absences.exams.map((exam, idx) => (
                              <div key={idx}>
                                {exam}
                                <label>
                                  Reiniciar{" "}
                                  <input
                                    type="checkbox"
                                    onChange={() =>
                                      handleReset(`absences.exams.${idx}`)
                                    }
                                  />
                                </label>
                              </div>
                            ))
                          : "No hay ausencias"}
                      </td>
                      <td className="pace_absence-control">
                        <input
                          type="text"
                          placeholder="ID de la clase"
                          value={classIdByPace[index] || ""}
                          onChange={(e) =>
                            setClassIdByPace((current) => ({
                              ...current,
                              [index]: e.target.value,
                            }))
                          }
                        />
                        <input
                          className="pace_search-button"
                          type="button"
                          value="Convertir"
                          onClick={() => handleConvert(pace, index)}
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
                <h4>Abordaje:</h4>
                <table>
                  <thead>
                    <tr>
                      <th>Sesión Regular</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>
                        {pace.approach?.regular_sessions?.length > 0
                          ? pace.approach.regular_sessions.map(
                              (session, idx) => (
                                <div key={idx}>
                                  {session}
                                  <label>
                                    Reiniciar{" "}
                                    <input
                                      type="checkbox"
                                      onChange={() =>
                                        handleReset(
                                          `approach.regular_sessions.${idx}`
                                        )
                                      }
                                    />
                                  </label>
                                </div>
                              )
                            )
                          : "No hay abordaje"}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ))}
            {isConfirmationDialogOpen && (
              <div className="confirmation-dialog">
                <p>¿Está seguro de validar la información?</p>
                <div className="pace_submit_container">
                  <input
                    className="pace_search-button"
                    type="button"
                    value="Cancelar"
                    onClick={handleCancel}
                  />
                  <input
                    className="pace_clear-button"
                    type="button"
                    value="Confirmar"
                    onClick={handleConfirm}
                  />
                </div>
              </div>
            )}
          </div>
        ) : responseData ? (
          <p>No hay datos disponibles</p>
        ) : null}
      </div>
    </div>
  );
};

export default Pace_modify;